export default [
    {
        path: "/shManifestRecognize/list",
        name: "ShManifestRecognizeList",
        component: () => import("@/views/ManifestMake/ShRecognize/list"),
        hidden: true,
        meta: {
            title: "舱单列表",
            activeMenu: "/shManifestRecognize/list",
            keepAlive: true,
        },
    },
    {
        path: "/shManifestRecognize/rsn",
        name: "ShManifestRecognizeRsn",
        component: () => import("@/views/ManifestMake/rsn"),
        hidden: true,
        meta: {
            title: "收发通",
            activeMenu: "/shManifestRecognize/rsn",
        },
    },
    {
        path: "/shManifestRecognize/mailAccount",
        name: "ShManifestRecognizeMailAccount",
        component: () => import("@/views/ManifestMake/mailAccount"),
        hidden: true,
        meta: {
            title: "邮箱管理",
            activeMenu: "/shManifestRecognize/mailAccount",
        },
    },
    {
        path: "/shManifestRecognize/edit",
        name: "ShManifestRecognizeEdit",
        component: () => import("@/views/ManifestMake/ShRecognize/edit.vue"),
        hidden: true,
        meta: {
            title: "上海舱单识别编辑",
            activeMenu: "/shManifestRecognize/list",
        },
    },
];
